"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const use_query_params_1 = require("use-query-params");
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
const core_2 = require("@sierralabs/core");
const core_ui_1 = require("@sierralabs/core-ui");
const forms_ui_1 = require("@sierralabs/forms-ui");
const user_ui_1 = require("@sierralabs/user-ui");
const workflow_core_1 = require("@sierralabs/workflow-core");
const useStateNodeByStatus_1 = require("../../../hooks/useStateNodeByStatus");
const useWorkflowItem_1 = require("../../../hooks/useWorkflowItem");
const useTaskFields_1 = require("../../../tasks/hooks/useTaskFields");
const SendForm_hooks_1 = require("./SendForm.hooks");
const StyledContainer = styled_components_1.default.main `
  flex: 1;
  height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  z-index: 0;
  .center-view {
    overflow-y: auto;
  }
`;
const StyledBody = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
`;
const StyledContent = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  display: flex;
  overflow: auto;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  background-color: #f1f3f3;
  .hidden {
    display: none;
  }
  .card-container {
    width: 100%;
    height: 100%;
    padding: 30px;
    .grid-center {
      &::before,
      &::after {
        content: '';
        flex: 1;
      }
    }
    .grid-actions {
      display: flex;
      padding-bottom: 30px;
      .spacer {
        flex: 1;
        display: flex;
        align-items: center;
        .text {
          margin-left: 16px;
          margin-right: 16px;
          line-height: unset;
        }
      }
    }
    .card-title {
      font-size: 24px;
      padding-top: 24px;
      font-weight: unset;
      line-height: unset;
      text-transform: unset;
      .MuiSvgIcon-root {
        margin-left: 10px;
        margin-right: 16px;
      }
    }
  }
`;
const TaskFormPage = () => {
    const [token] = (0, use_query_params_1.useQueryParam)('token', (0, use_query_params_1.withDefault)(use_query_params_1.StringParam, ''));
    const [stepIndex, setStepIndex] = (0, use_query_params_1.useQueryParam)('step', (0, use_query_params_1.withDefault)(use_query_params_1.NumberParam, 0));
    const contentRef = (0, react_1.useRef)(null);
    const [task, setTask] = (0, react_1.useState)();
    const [didUpdate, setDidUpdate] = (0, react_1.useState)(false);
    const [openSubmitDialog, setOpenSubmitDialog] = (0, react_1.useState)(false);
    const { result: verifyResult, isLoading, error, verifyToken } = (0, SendForm_hooks_1.useVerifyFormToken)();
    const [result, setResult] = (0, react_1.useState)(verifyResult);
    const invalidToken = (error === null || error === void 0 ? void 0 : error.statusCode) === 401;
    const formsCount = ((result === null || result === void 0 ? void 0 : result.formTemplates) || []).length;
    // submitted if task is in a different state
    const isSubmitted = (0, react_1.useMemo)(() => {
        return !!((result === null || result === void 0 ? void 0 : result.path) &&
            (task === null || task === void 0 ? void 0 : task.status) &&
            (result.path !== task.status ||
                (0, workflow_core_1.parseTaskStatus)(result.path) !== (0, workflow_core_1.parseTaskStatus)(task.status)));
    }, [result, task]);
    const completedDate = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        return (result &&
            isSubmitted &&
            ((_c = (_b = (_a = (task || result.task).data) === null || _a === void 0 ? void 0 : _a.sendForm) === null || _b === void 0 ? void 0 : _b[result.path]) === null || _c === void 0 ? void 0 : _c.completed));
    }, [isSubmitted, result, task]);
    const getEntity = (formTemplate) => {
        var _a;
        const id = (_a = formTemplate.entity) === null || _a === void 0 ? void 0 : _a.id;
        return !id || !result
            ? undefined
            : result.entities.find(e => e.id && e.id === id);
    };
    const setHeader = (0, react_1.useCallback)(() => {
        // set token header to api requests to allow PermissionGuard
        // to check and verify requests with SendForm token and
        // allow access without User entity
        const key = 'Send-Form-Authorization';
        if (!core_ui_1.api.environment.headers) {
            core_ui_1.api.environment.headers = {};
        }
        core_ui_1.api.environment.headers[key] = token;
        return () => {
            // remove headers
            if (core_ui_1.api.environment.headers) {
                delete core_ui_1.api.environment.headers[key];
            }
        };
    }, [token]);
    (0, react_1.useEffect)(() => {
        verifyToken(token);
    }, [token, verifyToken]);
    // make sure to set the header token before rendering forms
    (0, react_1.useEffect)(() => {
        if (verifyResult) {
            setResult(verifyResult);
            setTask(verifyResult.task);
            return setHeader();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [verifyResult]);
    // clear updated text on change step
    (0, react_1.useEffect)(() => {
        setDidUpdate(false);
    }, [stepIndex]);
    return (react_1.default.createElement(StyledContainer, null,
        react_1.default.createElement(core_1.AppBar, { square: true, color: 'secondary', position: 'static' },
            react_1.default.createElement(core_1.Toolbar, null,
                react_1.default.createElement("div", { className: 'content' },
                    react_1.default.createElement(core_1.Typography, { noWrap: true, variant: 'h6', className: 'logo-container' },
                        react_1.default.createElement("img", { width: 180, className: 'logo', alt: 'Sierra Labs', src: '/assets/sl-logo@2x.png' }))))),
        !result && !isLoading && error && (react_1.default.createElement(core_ui_1.ErrorView, { className: 'center-view', title: invalidToken
                ? 'Token has expired'
                : 'Unable to load Form information', description: error.message, icon: react_1.default.createElement(icons_1.Warning, { color: 'disabled', fontSize: 'inherit' }) })),
        !result && isLoading && !error && (react_1.default.createElement(core_ui_1.StyledCenterView, { className: 'center-view' },
            react_1.default.createElement("div", { className: 'content' },
                react_1.default.createElement(core_1.CircularProgress, { color: 'primary', size: 64 })))),
        result && (react_1.default.createElement(StyledBody, null,
            react_1.default.createElement(core_1.Hidden, { xsDown: true },
                react_1.default.createElement(core_ui_1.VerticalStepper, null,
                    result.formTemplates.map((formTemplate, index) => (react_1.default.createElement(core_ui_1.VerticalStep, { key: index, step: index + 1, label: formTemplate.name, completed: index < stepIndex, selected: index === stepIndex, onClick: () => setStepIndex(index) },
                        react_1.default.createElement("div", { className: 'step-index' },
                            react_1.default.createElement("span", { className: 'step-number' }, index + 1)),
                        react_1.default.createElement("div", { className: 'step-title' }, formTemplate.name)))),
                    react_1.default.createElement(core_ui_1.VerticalStep, { label: 'Completed', step: formsCount + 1, completed: stepIndex === formsCount, selected: stepIndex === formsCount, 
                        // allow only when form is completed
                        onClick: () => isSubmitted && setStepIndex(formsCount) },
                        react_1.default.createElement("div", { className: 'step-index' },
                            react_1.default.createElement("span", { className: 'step-number' }, formsCount + 1)),
                        react_1.default.createElement("div", { className: 'step-title' }, "Completed")))),
            react_1.default.createElement(StyledContent, { ref: contentRef },
                react_1.default.createElement("div", { className: 'card-container' },
                    react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(core_1.Grid, { container: true, spacing: 3, className: 'grid-center' },
                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 9, lg: 7 },
                                    result.formTemplates.map((formTemplate, index) => {
                                        return (react_1.default.createElement(RenderForm, { token: token, task: task || result.task, disabled: isSubmitted, formTemplate: formTemplate, entityData: result.entityData, entity: getEntity(formTemplate), key: `${formTemplate.id}-${index}`, className: stepIndex !== index ? 'hidden' : undefined, onUpdate: () => setDidUpdate(true) }));
                                    }),
                                    react_1.default.createElement(core_1.Card
                                    // visible if step is more than total
                                    // and task is in a different state
                                    , { 
                                        // visible if step is more than total
                                        // and task is in a different state
                                        className: stepIndex >= formsCount && isSubmitted
                                            ? undefined
                                            : 'hidden' },
                                        react_1.default.createElement(core_ui_1.CardTitle, null,
                                            react_1.default.createElement(icons_1.AssignmentTurnedIn, null),
                                            "Form Completed"),
                                        react_1.default.createElement(core_1.CardContent, null,
                                            react_1.default.createElement(core_1.Box, { mt: 1, mb: 2 },
                                                react_1.default.createElement(core_1.Typography, { variant: 'body1' }, "Thank you for taking the time to accomplish this form. You may now close this window.")),
                                            react_1.default.createElement(lab_1.Alert, { severity: 'success' },
                                                react_1.default.createElement("span", null,
                                                    "Form sucessfully accomplished",
                                                    completedDate && (react_1.default.createElement(react_1.default.Fragment, null,
                                                        ' on ',
                                                        react_1.default.createElement("strong", null, (0, core_2.formatDate)(completedDate)))),
                                                    "."))))))),
                        error && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(core_1.Grid, { container: true, spacing: 3, className: 'grid-center' },
                                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 9, lg: 7 },
                                    react_1.default.createElement(lab_1.Alert, { severity: 'error' }, error.message))))),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(core_1.Grid, { container: true, spacing: 3, className: 'grid-center' },
                                react_1.default.createElement(GridActions, { didUpdate: didUpdate, stepIndex: stepIndex, sectionsCount: formsCount, disableSubmit: isSubmitted, setStepIndex: setStepIndex, onSubmitClick: () => setOpenSubmitDialog(true) })))))))),
        react_1.default.createElement(SubmitFormDialog, { token: token, open: openSubmitDialog, onCancel: () => setOpenSubmitDialog(false), onSubmit: task => {
                setOpenSubmitDialog(false);
                setTask(task);
                setStepIndex(formsCount);
            } }),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: !!error }, error === null || error === void 0 ? void 0 : error.message)));
};
exports.default = TaskFormPage;
const StyledCard = (0, styled_components_1.default)(core_1.Card) `
  position: relative;
  .card-progress {
    top: 0;
    width: 100%;
    position: absolute;
  }
  .form-content {
    padding: 24px;
    .loading {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .form-empty-state {
      border: 2px dotted ${p => p.theme.palette.primary.main};
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 64px 24px;
    }
  }
`;
const RenderForm = props => {
    const { task, token, entity, entityData, formTemplate, disabled, className, onError, onUpdate } = props;
    const onErrorRef = (0, react_1.useRef)(onError);
    onErrorRef.current = onError;
    const onUpdateRef = (0, react_1.useRef)(onUpdate);
    onUpdateRef.current = onUpdate;
    const user = (0, user_ui_1.useUserContext)().user || undefined;
    const { workflow } = (0, useWorkflowItem_1.useWorkflowItem)(task, { token }) || {};
    const { entityData: updatedEntityData, isLoading, error, update } = (0, SendForm_hooks_1.useSendFormUpdate)(token, (entity === null || entity === void 0 ? void 0 : entity.tableName) || '', entityData.id || 0);
    const stateNode = (0, useStateNodeByStatus_1.useStateNodeByStatus)(task.status, workflow);
    const disableDataSources = (0, react_1.useMemo)(() => {
        const fields = ((entity === null || entity === void 0 ? void 0 : entity.columns) || []).map(column => column.name || (0, lodash_1.camelCase)(column.displayName));
        return disabled
            ? fields
            : fields.filter((0, useTaskFields_1.checkTaskFields)(stateNode, user).disabled);
    }, [disabled, entity, stateNode, user]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (updatedEntityData) {
            (_a = onUpdateRef.current) === null || _a === void 0 ? void 0 : _a.call(onUpdateRef, updatedEntityData);
        }
    }, [updatedEntityData]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (error) {
            (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, error);
        }
    }, [error]);
    return (react_1.default.createElement(StyledCard, { className: className },
        isLoading && react_1.default.createElement(core_1.LinearProgress, { className: 'card-progress' }),
        react_1.default.createElement(core_1.CardContent, { className: 'form-content' },
            react_1.default.createElement(forms_ui_1.FormProvider, { values: entityData, entitySchema: entity, formStateNode: formTemplate.config, disableDataSources: disableDataSources },
                react_1.default.createElement(forms_ui_1.EntityDataSource, { formData: entityData, handleUpdate: values => update(values) },
                    react_1.default.createElement(forms_ui_1.Form, { values: entityData }))))));
};
const GridActions = (props) => {
    const { stepIndex, sectionsCount, didUpdate, disableSubmit, setStepIndex, onSubmitClick } = props;
    return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 9, lg: 7, className: 'grid-actions' },
        stepIndex > 0 && (react_1.default.createElement(core_1.Button, { color: 'secondary', variant: 'contained', startIcon: react_1.default.createElement(icons_1.ChevronLeft, null), onClick: () => setStepIndex(stepIndex - 1) }, "Back")),
        react_1.default.createElement("div", { className: 'spacer' }, didUpdate && (react_1.default.createElement(core_1.Typography, { className: 'text', variant: 'body1' }, "Form details saved."))),
        stepIndex < sectionsCount - 1 && (react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', endIcon: react_1.default.createElement(icons_1.ChevronRight, null), onClick: () => setStepIndex(stepIndex + 1) }, "Next")),
        stepIndex === sectionsCount - 1 && (react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', disabled: disableSubmit, onClick: onSubmitClick, endIcon: react_1.default.createElement(icons_1.Send, null) }, "Submit"))));
};
const SubmitFormDialog = props => {
    const { open, token, onCancel, onSubmit } = props;
    const onSubmitRef = (0, react_1.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [error, setError] = (0, react_1.useState)();
    const { task, isLoading, error: completeError, completeForm } = (0, SendForm_hooks_1.useCompleteForm)();
    const handleCancel = () => {
        if (!isLoading) {
            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        }
    };
    // clear state
    (0, react_1.useEffect)(() => {
        !open && setError(undefined);
    }, [open]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (task) {
            (_a = onSubmitRef.current) === null || _a === void 0 ? void 0 : _a.call(onSubmitRef, task);
        }
    }, [task]);
    (0, react_1.useEffect)(() => {
        setError(completeError);
    }, [completeError]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: handleCancel },
        isLoading && react_1.default.createElement(core_1.LinearProgress, null),
        react_1.default.createElement(core_1.DialogTitle, null, "Submit Form"),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.DialogContentText, null,
                "Click the \"",
                react_1.default.createElement("strong", null, "Submit"),
                "\" button to save and complete the form."),
            react_1.default.createElement(lab_1.Alert, { severity: 'warning' },
                react_1.default.createElement(lab_1.AlertTitle, null, "Notice before submitting the Form"),
                react_1.default.createElement(core_1.Typography, { gutterBottom: true, variant: 'body2' },
                    "Further edits will be ",
                    react_1.default.createElement("strong", null, "disabled"),
                    " once submitted."),
                react_1.default.createElement(core_1.Typography, { variant: 'body2' }, "Please ensure that all necessary fields are filled out before submitting the form.")),
            react_1.default.createElement(core_1.Collapse, { in: !!error, style: { minHeight: 'unset' } },
                react_1.default.createElement(core_1.Box, { mt: 2 },
                    react_1.default.createElement(lab_1.Alert, { severity: 'error' }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.')))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { disabled: isLoading, onClick: handleCancel }, "Cancel"),
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', disabled: isLoading, onClick: () => completeForm(token) }, "Submit"))));
};
//# sourceMappingURL=TaskFormPage.js.map